class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = this.querySelector('#cart-notification');
    this.message = this.querySelector('[data-cart-toast-message]');
  }

  open() {
    clearTimeout(this.dismissTimer);
    cancelAnimationFrame(this.announcementFrame);
    this.message.textContent = '';
    this.notification.classList.add('active');
    // Repopulate the mounted live region for every successful add.
    this.announcementFrame = requestAnimationFrame(() => {
      this.message.textContent = this.notification.dataset.message;
      this.dismissTimer = setTimeout(() => this.close(), 4000);
    });
  }

  close() {
    clearTimeout(this.dismissTimer);
    cancelAnimationFrame(this.announcementFrame);
    this.notification.classList.remove('active');
    this.message.textContent = '';
  }

  disconnectedCallback() {
    this.close();
  }

  renderContents(parsedState) {
    // Keep the native section contract and badge refresh without a dialog.
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections?.[section.id];
      if (target && typeof html === 'string') {
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      }
    });
    this.open();
  }

  getSectionsToRender() {
    return [{ id: 'cart-icon-bubble' }];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  setActiveElement(element) {
    // Product forms call this API; a status toast never moves focus.
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
